import { useEffect, useState } from 'react';

// Breakpoint móvil del CMS. Reactivo al resize y a la rotación del dispositivo.
export const MOBILE_BREAKPOINT = 768;

const query = `(max-width: ${MOBILE_BREAKPOINT}px)`;

const getMatch = () =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(query).matches
    : false;

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(getMatch);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;

    const mql = window.matchMedia(query);
    const handler = (event) => setIsMobile(event.matches);

    setIsMobile(mql.matches);

    // Safari < 14 no soporta addEventListener sobre MediaQueryList
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', handler);
      return () => mql.removeEventListener('change', handler);
    }
    mql.addListener(handler);
    return () => mql.removeListener(handler);
  }, []);

  return isMobile;
};

export default useIsMobile;
